import type { Report } from "@plataforma/shared";

/** CSV para planilhas em português: separador ";", decimal com vírgula e proteção contra fórmulas. */
export function reportToCsv(report: Report): string {
  const cell = (value: string | number) => {
    if (typeof value === "number") return value.toFixed(2).replace(".", ",");
    const text = /^[=+\-@]/.test(value) ? `'${value}` : value;
    return `"${text.replaceAll('"', '""')}"`;
  };
  const line = (cells: (string | number)[]) => cells.map(cell).join(";");
  const lines = [line([report.title]), line([report.period]), "", line(["Resumo"]), ...report.summary.map((item) => line([item.label, item.value]))];
  for (const section of report.sections) {
    lines.push("", line([section.title]), line(section.columns), ...section.rows.map(line));
    if (section.total && section.rows.length) lines.push(line(section.total));
  }
  lines.push("", ...report.notes.map((note) => line([note])));
  return lines.join("\r\n");
}

/** Marca de ordem de bytes: faz o Excel reconhecer o arquivo como UTF-8. */
const BYTE_ORDER_MARK = String.fromCharCode(0xfeff);

export function downloadText(fileName: string, content: string, type: string): void {
  const link = document.createElement("a");
  link.href = URL.createObjectURL(new Blob([BYTE_ORDER_MARK + content], { type }));
  link.download = fileName;
  document.body.append(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(link.href);
}
